import { FC } from "react";
import { Route } from "react-router-dom";
import AuthenticatedAppShell from "../../components/AuthenticatedAppShell";
import Calculation from "../../pages/calculations/Calculation";
import Calculations from "../../pages/calculations/Calculations";
import { DECK_DESIGNER_ENGINE_ID } from "../../pages/engines/registry";
import Menu from "./Menu";

const AuthenticatedApp: FC = () => (
  <AuthenticatedAppShell Menu={Menu}>
    <Route index element={<Calculations moduleId={DECK_DESIGNER_ENGINE_ID} />} />
    <Route path="my-calculations" element={<Calculations moduleId={DECK_DESIGNER_ENGINE_ID} />} />
    <Route path="my-calculations/:calculationId" element={<Calculation />} />
  </AuthenticatedAppShell>
);

export default AuthenticatedApp;
